'use strict';
const React = require('react');
const toastr = require('toastr');
const Currency = require('currency-symbol-map');
const CommonModule = require('../../public/js/common');
const BaseComponent = require('../../views/shared/base');
var EnumCoreModule = require('../../public/js/enum-core');
const MoqComponent = require('../features/pricing_type/' + process.env.PRICING_TYPE + '/item-details/moq');
const OriginalPriceComponent = require('../features/pricing_type/' + process.env.PRICING_TYPE + '/item-details/original-price');
const SellerInfoComponent = require('../features/pricing_type/service_level/item-details/seller-info');
let client = require('../../../sdk/client');

class PurchaseOrderComponent extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            valuesupercesor: "",
            valueantecesor: "",
            selectedVariantIDs: new Map(),
            productQuantity: 0,
            temporalProductQuantity: 0,
        }
        this.isboolUpdateQuantity = false;
        this.ProductQuantity;
    }

    componentDidMount() {
        const self = this;
        $('.idcrt-order-val select').on('change', function () {
            const groupID = $(this).attr('data-group-id');
            self.setState({
                selectedVariantIDs: self.state.selectedVariantIDs.set(groupID, this.value)
            }, function () {
                const { bulkPricing, priceValues } = self.props;
                const itemPrice = self.getItemPrice();

                self.props.updateQuantity(priceValues.quantity, itemPrice, bulkPricing);
            });
        });

        // reset values of uncontrolled react components
        if (window) {
            $(window).on('pageshow', function () {
                $('.idcrt-order-val select').each(function () {
                    $(this).val('');
                });
                $('input[name="item-qty"]').val('');
            });
        }

        this.setThumbnailImage();

        //Enter key listener to inputs, just to trigger blur event when enter key is pressed.
        document.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') {
                $(e.path[0]).blur();
            }
        });
        this.updatePartQty();
        
        setTimeout(function(){
            var clientType = $("#clientType").val();    
            var partQty = $("#partQty").text();
            partQty = Number(partQty); 

            if ((clientType == "B2C" || clientType == "B2B") && partQty > 0) {
                $('#itemAddCart').removeClass("disabled");
            } else {
                if(self.isThisUserB2C()){
                    //Cart funcionality
                    //$('#itemAddCart').addClass("disabled");
                }
                if (clientType == "B2B") {
                    $('#negotiate').removeClass("hide");
                }
            }
        }, 5000);
        
        var partQtyElement = $("#partQty").text();
    }
    
    updatePartQty() {
        var partQtyElement = $("#partQty").text();
        partQtyElement = Number(partQtyElement)
        this.ProductQuantity = partQtyElement;  
    }

    componentDidUpdate() {
        if ($('span.total-stock').length > 0) {
            const item = this.getItem();
            const totalStock = item.StockLimited == false ? "&infin;" : item.StockQuantity || 0;

            $('span.total-stock').html(totalStock);
        }

        this.setThumbnailImage();
    }

    isItemAntecesor(itemdetails) {
        let boolisItemAntecesor = false;
        let supercesor = itemdetails.CustomFields.find(x => x.Code == process.env.CF_SUPERCESOR);
        let numeroparte = itemdetails.CustomFields.find(x => x.Code == process.env.CF_PART_NUMBER);

        let strNumeroParte = "-";

        if (
            numeroparte != undefined
        ) {
            strNumeroParte = numeroparte.Values[0];
        }

        let strSupercesor = "-";
        if (
            supercesor != undefined
        ) {
            strSupercesor = supercesor.Values[0];
        }


        if (strNumeroParte != strSupercesor) {
            boolisItemAntecesor = true;
        }
        return boolisItemAntecesor;

    }

    isB2BUser(customFields) {
        // Base case: if customFields is not an array or empty
        if (!Array.isArray(customFields) || customFields.length === 0) {
            return false;
        }

        for (let field of customFields) {
            // Check if the current field is the one that determines the user type
            if (field.Name === "Tipo de Usuario" && field.Values[0] === "B2B") {
                return true;
            }

            // If the field has nested custom fields, search them recursively
            if (field.CustomFields) {
                if (isB2BUser(field.CustomFields)) {
                    return true;
                }
            }
        }

        // If no B2B user type is found
        return false;
    }

    addItemToCart(e) {
        const self = this;

        //user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0]=="B2C"
        var userIsB2C;
        //Cart funcionality
        if(this.props.user.CustomFields) {
            try {
                userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
            } catch (error) {
                console.error(".Find error:", error);
            }
        } else {
            userIsB2C = "B2C";
        }
        var userIsB2B;
        if(this.props.user.CustomFields) {
            try {
                userIsB2B = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2B";
            } catch (error) {
                console.error(".Find error:", error);
            }
        }
        let item = this.getItem();
        var partQty = $("#partQty").text();
        partQty = Number(partQty);
        var errPrompt = [];
        if (this.props.processing === true) {
            return;
        }
        $('.minimum-order-not-met-error-container').hide();
        $('.not-enough-stock-error-container').hide();
        $('.required').removeClass('error-con');
        if (self.props.user.Guest && self.props.controlFlags.GuestCheckoutEnabled === false) {
            toastr.error('Feature not available yet for guest user.')
            return;
        }
        let hasEmpty = false;
        $('.idcrt-order-val .required').each(function () {
            if ($.trim(jQuery(this).val()) == '') {
                hasEmpty = true;
                $(this).addClass('error-con');
            }
        });
        if (hasEmpty == true) return;
        const parentItem = this.props.itemDetails;
        const { HasChildItems, ChildItems } = parentItem;
        if (HasChildItems && ChildItems.length > 0) {
            if (ChildItems[0].Variants && ChildItems[0].Variants.length > 0) {
                if (this.state.selectedVariantIDs.size !== ChildItems[0].Variants.length) {
                    return;
                }
            }
        }
        const { priceValues } = this.props;
        var input = $("#qty-" + 1);
        var intInputValue = "";
        if (
            !isNaN(input.val())
        ) {
            intInputValue = parseInt(input.val());
        }

        if (priceValues.quantity == 0){
            priceValues.quantity = intInputValue;
        }
        
        if (priceValues.quantity < 1) {
            toastr.error('Favor de ingresar la cantidad.', 'Error!');
            $('input[name="item-qty"]').addClass('error-con');
            return;
        }
        if (userIsB2C) {
            if (isNaN(partQty) || (parseInt(partQty) - priceValues.quantity) < 0) {
                $('#negotiate').removeClass("hide");
                toastr.error('No hay suficiente stock para este producto, puedes contactar al vendedor para más información.', 'Error');
                return;
            }
        } else {
            if (item.StockLimited && (parseInt(item.StockQuantity) - priceValues.quantity) < 0) {
                $('.not-enough-stock-error-container').show();
                $('input[name="item-qty"]').addClass('error-con');
                return;
            }
        }
        var userId;
        if (this.props.user && parentItem.MerchantDetail.ID === this.props.user.ID) {
            toastr.error('This item seems to belong to you.', 'Oops! Something went wrong.');
            return;
        }
        const moq = this.getMoq();
        if (moq && moq > priceValues.quantity) {
            $('.minimum-order-not-met-error-container').show();
            $('input[name="item-qty"]').addClass('error-con');
            return;
        }
        
        if(priceValues.quantity > 0){
            //this.state.temporalProductQuantity += priceValues.quantity;
        }
        if(userIsB2C){
            if(this.state.temporalProductQuantity > partQty){
                //toastr.error('No hay suficiente stock para este producto, puedes contactar al vendedor para más información.', 'Error');
                //return;
            }
        }
        this.props.setProcessing(true);

        let guestUserID = "";
        if (!this.props.user) {
            if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                guestUserID = CommonModule.getCookie("guestUserID");
            }
        } else {
            userId = this.props.user.ID;
        }

        const options = {
            pageSize: 100,
            pageNumber: 1,
            includes: null,
            guestUserID: guestUserID
        };
        var itemflag= false;
        var itemqtyTemp= this.state.temporalProductQuantity;
        this.props.getUserCarts(options, function (cartList) {
            let quantityToPass = priceValues.quantity;
            let cartItemId = null;
            const itemExistsInCartLocal = cartList.find(cl => cl.ItemDetail.ID == item.ID);
            if (process.env.PRICING_TYPE != 'service_level') {
                const itemExistsInCart = cartList.find(cl => cl.ItemDetail.ID == item.ID);
                cartItemId = itemExistsInCart ? itemExistsInCart.ID : null;
                if (itemExistsInCart) {
                    quantityToPass = parseInt(priceValues.quantity) + parseInt(itemExistsInCart.Quantity);
                }
            }
            if(itemExistsInCartLocal){
                var itemQty = itemExistsInCartLocal.Quantity;
                var qtyFinal = itemQty;
                console.log("PriceValues", priceValues.quantity);
                console.log("itemQty", itemQty);
                console.log("qtyFinal", qtyFinal);
                console.log("partQty", partQty);
                if ((qtyFinal + priceValues.quantity) > partQty && self.isThisUserB2C === true) {
                    toastr.error('No hay suficiente stock para este producto, puedes contactar al vendedor para más información.', 'Error');
                    self.props.setProcessing(false);
                    return;
                } else {
                    const options = {
                        selectedQuantity: priceValues.quantity,
                        discount: priceValues.discount,
                        itemId: item.ID,
                        force: true,
                        isComparisonOnly: false,
                        ServiceBookingUnitGuid: null,
                        bookingSlot: null
                    };

                    window.gtag("event", "add_to_cart", {
                        'app_name': 'Megamak',
                        'item_added': 'Item: ' + item.BuyerDescription
                    });

                    self.props.addOrEditCart(cartItemId, quantityToPass, options,
                        (cartItem) => self.handleAddToCartSuccess(),
                        (errorMessage) => self.showMessage(errorMessage)
                    );
                }
            }else{
                const options = {
                    selectedQuantity: priceValues.quantity,
                    discount: priceValues.discount,
                    itemId: item.ID,
                    force: true,
                    isComparisonOnly: false,
                    ServiceBookingUnitGuid: null,
                    bookingSlot: null
                };

                window.gtag("event", "add_to_cart", {
                    'app_name': 'Megamak',
                    'item_added': 'Item: ' + item.BuyerDescription
                })

                self.props.addOrEditCart(cartItemId, quantityToPass, options,
                    (cartItem) => self.handleAddToCartSuccess(),
                    (errorMessage) => self.showMessage(errorMessage)
                );
            }
        });
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();

        setTimeout(function () {
            self.props.setProcessing(false);
        }, 1000);
    }

    contactSeller() {
        const self = this;

        if (this.props.processing === true) {
            return;
        }

        $('.minimum-order-not-met-error-container').hide();
        $('.not-enough-stock-error-container').hide();
        $('.required').removeClass('error-con');

        const userDetail = self.props.user;
        const itemDetail = self.props.itemDetails;

        if (userDetail.ID === itemDetail.MerchantDetail.ID) {
            toastr.error('Cannot open chat, this item seems to belong to you.', 'Oops! Something went wrong.');
            return;
        }

        const parentItem = self.props.itemDetails;
        let item = parentItem.HasChildItems ? this.getItem() : self.props.itemDetails;
        const priceValues = self.props.priceValues;

        const options = {
            pageSize: 100,
            pageNumber: 1,
            includes: ['CartItemDetail', 'ItemDetail', 'User']
        }
        //https://arcadier.atlassian.net/browse/ARC-9117
        let hasEmpty = false;
        $('.idcrt-order-val .required').each(function () {
            if ($.trim(jQuery(this).val()) == '') {
                hasEmpty = true;
                $(this).addClass('error-con');
            }
        });


        //https://arcadier.atlassian.net/browse/ARC-9117
        if (hasEmpty) return;

        if (item.StockLimited === true) {
            if ((parseInt(item.StockQuantity) - priceValues.quantity) < 0) {
                $('.not-enough-stock-error-container').show();
                $('input[name="item-qty"]').addClass('error-con');
                return;
            }
        }

        this.props.setProcessing(true);

        this.props.getUserChannels(options, function (channels) {
            let createNewChannel = false;
            let channel = null;

            //TODO: adjust API to include and check for open channels with pending offer
            if (channels && channels.TotalRecords === 0) {
                createNewChannel = true;
            }
            else {
                for (let i = 0; i < channels.TotalRecords; i++) {
                    let tempChannel = channels.Records[i];
                    if (tempChannel && tempChannel.ItemDetail) {
                        if (tempChannel.ItemDetail.ID === item.ID) {
                            channel = tempChannel;
                            break;
                        }
                        if (tempChannel && tempChannel.CartItemDetail && tempChannel.CartItemDetail.ItemDetail.ID === item.ID) {
                            channel = tempChannel;
                            break;
                        }
                    }
                }
                createNewChannel = !channel;
            }

            function getChatDetails(channel, callback) {
                if (channel) {
                    self.props.getChatDetails(channel.ChannelID, function (details) {
                        callback(details);
                    });
                } else {
                    callback();
                }
            }
            $(".btn-loader").addClass('btn-loading');
            getChatDetails(channel, function (chatDetails) {
                if (chatDetails && chatDetails.Channel && chatDetails.Channel.Offer && chatDetails.Channel.Offer.Accepted) {
                    createNewChannel = true;
                }

                if (createNewChannel) {
                    self.props.createChatChannel({
                        recipientId: itemDetail.MerchantDetail.ID,
                        itemId: item.ID,
                        quantity: priceValues.quantity,
                        createCartItem: true
                    }, function (newChannel) {
                        $(".btn-loader").removeClass('btn-loading');
                        if (newChannel && newChannel != "") {
                            window.location = "/chat?channelId=" + newChannel.ChannelID;
                        } else {
                            toastr.error('Error creating chat channel.', 'Error!');
                            self.props.setProcessing(false);
                        }
                    });
                }
                else {
                    $(".btn-loader").removeClass('btn-loading');
                    toastr.error('You still have an open channel/offer for this item.', 'Oops! Something went wrong.');
                    window.location = "/chat?channelId=" + channel.ChannelID;
                }
            });
        });
    }

    getLatestCartList() {
        let guestUserID = "";

        if (this.props.user && this.props.user.Guest !== undefined) {
            if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                guestUserID = CommonModule.getCookie("guestUserID");
            }
        }
        if (!this.props.user) {
            if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
                guestUserID = CommonModule.getCookie("guestUserID");
            }
        }

        const options = {
            pageSize: 100,
            pageNumber: 1,
            includes: null,
            guestUserID: guestUserID
        };

        this.props.getUserCarts(options, null);
    }

    getItem() {
        const { HasChildItems, ChildItems } = this.props.itemDetails;
        const { selectedVariantIDs } = this.state;
        const selectedVariantArr = [...selectedVariantIDs.values()];
        let item = this.props.itemDetails;

        // get child item with variants that matches the current selected variants
        if (HasChildItems && ChildItems.length > 0 && selectedVariantArr) {
            for (const ch in ChildItems) {
                const { Variants } = ChildItems[ch];
                if (Variants && Variants.length === selectedVariantArr.length) {
                    const variantIds = Variants.map(v => v.ID);
                    const isMatch = selectedVariantArr.every(e => variantIds.includes(e));
                    if (!isMatch) continue;

                    item = ChildItems[ch];
                }
            }
        }

        return item;
    }

    getItemPrice() {
        return this.getItem().Price || 0;
    }

    getMoq() {
        const { ChildItems } = this.props.itemDetails;
        let moq = '';

        if (ChildItems && ChildItems.length > 0) {
            const { CustomFields } = ChildItems[0];

            if (CustomFields && CustomFields.length > 0) {
                const moqCustomField = CustomFields.find(c => c.Code.startsWith('moq'));

                if (moqCustomField && moqCustomField.Values && moqCustomField.Values.length > 0) {
                    moq = parseFloat(moqCustomField.Values[0]).toFixed();
                }
            }
        }

        return moq;
    }

    handleAddToCartSuccess() {
        function fadeOutCart() {
            var target = $(".h-cart .h-dd-menu.add-cart");
            setTimeout(function () {
                target.removeClass('fadeout');
            }, 3000);
        }

        function isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
                return true;
            }
            return false;
        }

        const { CurrencyCode, Media, Name } = this.props.itemDetails;
        const { bulkPricing, priceValues } = this.props;
        this.getLatestCartList();
        //const cartSubTotal = (this.getItemPrice() * this.props.priceValues.quantity).toFixed(2);
        const addedItem = this.getItem();
        let image = addedItem.Media && addedItem.Media.length > 0 ? addedItem.Media[0].MediaUrl : '';

        if (!image) {
            image = Media && Media.length > 0 ? Media[0].MediaUrl : '';
        }

        // TODO: Find a better approach to do this.
        // Note: The code below uses the bepensa-lider client prices if available since this child component code has loaded
        // those custom prices.
        let numExchangeCurrency = $("#exchange-currency").attr("currency");
        let strSpanClientPrice = $(".price-i-detail.price-cdesc.item-categ").text();
        let currencyCodeCf = this.props.itemDetails.CustomFields.find(x => x.Name == "Currency");
        let strCurrencyCode = "";

        if (currencyCodeCf != undefined || currencyCodeCf != null) {
            if(currencyCodeCf.Values[0].length > 0){
                strCurrencyCode = currencyCodeCf.Values[0];
            }                        
        }
       
        let roundOffSubTotal = priceValues.bulkPrice;
        let boolCalculatedPrice = false;
        if(strSpanClientPrice != undefined){
            let numClientPrice = strSpanClientPrice.replace("$","").replace(",","").replace("MXN","").trim();
            roundOffSubTotal = parseFloat(numClientPrice); 
            boolCalculatedPrice = true;
        }
        
        if (
            !boolCalculatedPrice && numExchangeCurrency != undefined && numExchangeCurrency != "-" && strCurrencyCode == "USD"
            )
        {
            roundOffSubTotal = roundOffSubTotal * parseFloat(numExchangeCurrency);
        }

        strCurrencyCode = "MXN";

        var priceModal = document.getElementsByClassName('price-i-detail price item-categ')[0].innerText.split(' ')[1];

        $(".h-cart .h-dd-menu.add-cart").addClass('fadeout');
        $('.h-cart .h-dd-menu.add-cart.fadeout').css('display', '');
        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-img > img').attr('src', image);
        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > p').text(Name);
        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .currency').text(`${strCurrencyCode} ${Currency(strCurrencyCode)}`);
        $('.h-cart .h-dd-menu.add-cart.fadeout > .h-cart-mid > ul > .cart-item > .item-info > .item-price > .value').text(priceModal);
        this.props.updateQuantity(0, this.getItemPrice(), bulkPricing);
        $('input[name="item-qty"]').val('');

        $('html, body').animate({
            'scrollTop': $(".h-cart").position().top
        });
        var itemImg = $(".idclt-img > img");
        /*if (!isMobile()) {
            var t = window.flyToElement($(itemImg), $('.h-cart'));
        }*/
        fadeOutCart();
        return false;
    }

    setThumbnailImage() {
        const item = this.getItem();
        const { Media } = item;

        if (Media && Media.length > 0) {
            $('.item-main-thumbnail').attr('href', Media[0].MediaUrl);
            $('.item-main-thumbnail').attr('data-lightbox', Media.length > 1 ? 'gallery-group' : 'gallery');
            $('.item-main-thumbnail > img ').attr('src', Media[0].MediaUrl);
        }
    }

    renderQuantityAlert() {
        const { HasChildItems, ChildItems } = this.props.itemDetails;
        const { selectedVariantIDs } = this.state;
        const selectedVariantArr = [...selectedVariantIDs.values()];

        let item = null;

        if (HasChildItems && ChildItems.length > 0 && selectedVariantArr) {
            for (const ch in ChildItems) {
                const { Variants } = ChildItems[ch];
                if (Variants && Variants.length > 0 && Variants.length === selectedVariantArr.length) {
                    const VariantIds = Variants.map(v => v.ID);
                    const isMatch = selectedVariantArr.every(e => VariantIds.includes(e));
                    if (!isMatch) continue;
                    item = ChildItems[ch];
                }
            }
        } else item = this.props.itemDetails;

        if (item) {
            if (item.StockLimited == true && parseInt(item.StockQuantity) <= 5) {
                return (<span className="quantity-alert">Only {item.StockQuantity} left!</span>);
            }
        }
        return;
    }

    renderVariants() {
        const { HasChildItems, ChildItems } = this.props.itemDetails;

        function groupBy(xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        };

        if (HasChildItems && ChildItems.length > 0) {
            const ChildItemArr = ChildItems.filter(c => c.Variants && c.Variants.length > 0);
            if (ChildItemArr && ChildItemArr.length > 0) {
                let variants = [];
                ChildItemArr.map(ch => variants.push(...ch.Variants));
                if (variants && variants.length > 0) {
                    // remove duplicates
                    variants = variants.reduce((acc, cur) => {
                        let result = acc.find(a => JSON.stringify(a) == JSON.stringify(cur));
                        if (!result)
                            return acc.concat(cur);
                        return acc;
                    }, []);
                    const variantGroups = groupBy(variants, 'GroupID');
                    return Object.values(variantGroups).map(vg =>
                        <span className="full-width" key={vg[0].GroupName}>
                            <span className="title full-width">{vg[0].GroupName}:</span>
                            <span className="idcrtl-right full-width relation">
                                <select className="full-width required" data-group-id={vg[0].GroupID}>
                                    <option value={''}></option>
                                    {
                                        vg.map(variant =>
                                            <option
                                                key={variant.ID}
                                                value={variant.ID}>
                                                {variant.Name}
                                            </option>
                                        )
                                    }
                                </select>
                            </span>
                        </span>
                    )
                }
            }
        }

        return '';
    }

    // Component Qty 
    updateQuantityinput(strDeltaType, itemPrice, bulkPricing) {
        var input = $("#qty-" + 1);
        let availability = this.props.availability;
        let salesUnit = this.props.salesUnit != undefined ? parseInt(this.props.salesUnit) : 1;
        var isOverFlowStock = false;
        var intValueUnit = 0;
        if (availability == "-") {
            availability = 0;
        }

        var intInputValue = 0;

        if (!isNaN(input.val())) {
            intInputValue = parseInt(input.val());
        }
        if (this.isboolUpdateQuantity) {
            if(strDeltaType == "plus" ){
                intInputValue = intInputValue - salesUnit
            }
        } 
        
        if (intInputValue == 0) {
            intValueUnit = salesUnit;
        }
        else if (intInputValue > 0) {
            if (this.isMultiple(input.val(), salesUnit)) {
                intValueUnit = salesUnit;
            } else {

                if (intInputValue < salesUnit) {
                    //intInputValue = 0;
                    if (strDeltaType == "plus") {
                        intValueUnit = salesUnit;
                    } else {
                        intValueUnit = salesUnit;
                    }
                } else {

                    // Arrays que contendran los valores multiples de salesUnit
                    let multiples_salesUnit = [];

                    var aux = input.val() * salesUnit;

                    // bucle del 1 a aux
                    for (var i = 1; i <= aux; i++) {

                        if (this.isMultiple(i, salesUnit)) {

                            multiples_salesUnit.push(i);
                        };

                        for (let index = 0; index < multiples_salesUnit.length; index++) {
                            const element = multiples_salesUnit[index];                                                           

                            if (input.val() < element) {
                                intInputValue = 0;
                                intValueUnit = element;
                                break;
                            }
                        }
                    }
                }
            }
        }

        if (
            strDeltaType == "plus"
        ) {
            intInputValue += intValueUnit;

            if (this.isItemAntecesor(this.props.itemDetails) && (intInputValue > availability)) {
                isOverFlowStock = true;
            }

        }
        else if (
            strDeltaType == "minus"
        ) {
            if(intInputValue == salesUnit){
                intInputValue = salesUnit;
            }else{
                intInputValue -= intValueUnit;
            }
           
        }

        //Update UI, not allowed negative values
        if (
            intInputValue >= 0 && !isOverFlowStock
        ) {
            input.val(intInputValue);
            this.props.updateQuantity(intInputValue, itemPrice, bulkPricing)
        }
        this.isboolUpdateQuantity = false;    
    
    }

    isMultiple(quantity, unit) {

        var boolIsMultiple = false;
        var resto = quantity % unit;

        if (resto == 0) {
            boolIsMultiple = true;
        } else {
            boolIsMultiple = false;
        }
        return boolIsMultiple;
    }    

    itemOnChangeListener(itemPrice, bulkPricing) {
        var input = $("#qty-" + 1);       

        var intInputValue = 0;
        let salesUnit = this.props.salesUnit != undefined ? parseInt(this.props.salesUnit) : 1;

        if (
            !isNaN(input.val())
        ) {
            intInputValue = parseInt(input.val());
        }

        if (intInputValue == 0) {
            intInputValue = salesUnit;
        }
        else if (intInputValue > 0) {
            if (this.isMultiple(input.val(), salesUnit)) {
                intInputValue = intInputValue;
            } else {
                if (intInputValue < salesUnit) {
                    intInputValue = salesUnit;
                } else {
                    // Arrays que contendran los valores multiples de salesUnit
                    let multiples_salesUnit = [];
                    var aux = input.val() * salesUnit;

                    for (var i = 1; i <= aux; i++) {
                        if (this.isMultiple(i, salesUnit)) {
                            multiples_salesUnit.push(i);
                        };

                        for (let index = 0; index < multiples_salesUnit.length; index++) {
                            const element = multiples_salesUnit[index];
                            if (input.val() < element) {
                                intInputValue = element;
                                break;
                            }
                            
                        }
                    }
                }
            }
        }
        input.val(intInputValue);        
        this.props.updateQuantity(intInputValue, itemPrice, bulkPricing);
        this.isboolUpdateQuantity = true;     
       
    }

    renderCPLS() {
        const item = this.getItem();


        var cpls = item.CustomFields.filter(function (item) { return item.Code === process.env.CF_CPL; });
        var valueCPL = "";

        if (cpls.length > 0) {
           valueCPL = cpls[0].Values[0];
           valueCPL = valueCPL.replace(/,/g, ", ");
        }

        var classCPL = (valueCPL == "") ? "hide" : "";

        return <div id="container-info-cpls" className={"item-details " + classCPL}>
            <span className="">CPLs:</span>
            <span className="item-categ"><p><span>{valueCPL}</span></p></span>
        </div>
    }

    renderPartesRelacionadas() {
        const item = this.getItem();

        var partes = item.CustomFields.filter(function (item) { return item.Code === process.env.CF_RELATED_PART; });
        var parte = "";

        if (partes.length > 0) {
            parte = partes[0].Values[0];
        }

        return <div id="container-info-partes">
            <span className="">Partes Relacionadas: </span>
            <span className="item-categ"><p><span id="partes">{parte}</span></p></span>
        </div>
    }

	isThisUserB2C(){
        var userIsB2C = true;
        //Cart funcionality
        if(this.props.user.CustomFields) {
            try {
                userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
            } catch (error) {   
                console.error(".Find error:", error);
            }
        } else {
            userIsB2C = true;
        }
		return userIsB2C;
	}

    btnCartClasses(){
        let classes = 'btnaddCart btn-group btn-cart';

        if(this.isThisUserB2C()){
            //Cart funcionality
            ///classes += ' disabled';
        }

        return classes;
    }

    render() {
        const item = this.getItem();
        const { priceValues } = this.props;
        let stockAvailable = isNaN(parseInt(this.ProductQuantity)) ? false : true;
        const itemPrice = this.getItemPrice();
        const isNegotiate = this.props.itemDetails && !this.props.itemDetails.Negotiation ? "hide" : "";
        //const itemHasStock = ((stockAvailable === true)) ? "hide" : "";
        const itemHasStock = stockAvailable ? "" : "hide";
        const isSpotPurchase = this.props.itemDetails && !this.props.itemDetails.InstantBuy ? "hide" : "";
        const self = this;
        const userDetail = self.props.user;
        var userIsB2C = true;
        if(this.props.user.CustomFields) {
            try {
                userIsB2C = this?.props?.user?.CustomFields.find(x => x.Name == "Tipo de Usuario")?.Values[0] === "B2C";
            } catch (error) {
                console.error(".Find error:", error);
            }
        } else {
            userIsB2C = true;
        }
        const shouldRenderContactButton = userIsB2C;
        var usuarioConsulta = '';
        if (userDetail && userDetail.Guest) {
            //Cart funcionality
            //usuarioConsulta = 'hide';
        }


        return (
            <div className="idcr-top pull-left w-100" id="container-purchase-order">
                <div className="idcrt-order-val pull-left w-100" id="sub-container-purchase-order">
                    <div className="idcrt-list-val cpls" id="">
                        {
                            /*
                            {this.renderVariants()}
                            <span className="idcrtl-price full-width">
                                <span className="title">Price per item:</span>
                                <span className="idcrtl-right">
                                    <div className="item-price">
                                        {this.renderFormatMoney(this.props.itemDetails.CurrencyCode, itemPrice)}
                                    </div>
                                </span>
                            </span>*/
                        }
                        <span className="idcrtl-qty full-width">
                            <span className={"txt-info-item-detail " + usuarioConsulta}>Cantidad:</span>
                            {/*
                            <span className="idcrtl-right">
                                <input name="item-qty" type="number" step="1" onChange={(e) => this.props.updateQuantity(e.target.value, itemPrice, this.props.bulkPricing)} className="required numbersOnly" min="0" />
                                {this.renderQuantityAlert()}
                            </span>*/
                            }                            
                            <div className={"bp-quantity-controls " + usuarioConsulta} id="container-bp-quantity-controls">
                                <div className="bp-quantity-control-box btn-quantity-itemdetail" onClick={() => this.updateQuantityinput('minus', itemPrice, this.props.bulkPricing)}>-</div>
                                <div id="container-inputquantity"><input type="number" id={"qty-" + 1} defaultValue={this.props.salesUnit} onChange={(e) => this.props.updateQuantity(e.target.value, itemPrice, this.props.bulkPricing)} onBlur={() => this.itemOnChangeListener(itemPrice, this.props.bulkPricing)}></input></div>
                                <div className="bp-quantity-control-box btn-quantity-itemdetail" onClick={() => this.updateQuantityinput('plus', itemPrice, this.props.bulkPricing)}>+</div>

                                <div className="idcrt-order-btn pull-left w-100" id="container-btnaddCart">
                                    <div className={this.btnCartClasses()} 
                                        id="itemAddCart" 
                                        onClick={(e) => this.addItemToCart(e)}>
                                        Comprar
                                    </div>
                                    {/* <div className={`btnaddCart btn-group btn-cart ${this.props.itemDetails.StockQuantity === 0 ? 'disabled' : ''}`} 
                                        id="itemAddCart" 
                                        onClick={(e) => this.props.itemDetails.StockQuantity !== 0 && this.addItemToCart(e)}>
                                        Agregar al carrito
                                    </div> */}
                                    {shouldRenderContactButton && (
                                        <div className={"btnContactMerchant btn-group " + itemHasStock} style={{padding: '4px', marginLeft: '15px'}} id="negotiate" onClick={() => this.contactSeller()}>Contactar al vendedor</div>
                                    )}
                                    
                                </div>
                            </div>

                        </span>
                        <span className="txt-info-item-detail">Los impuestos serán calculados al momento de entrar al carrito.</span>

                        {this.renderCPLS()}

                        {/* <MoqComponent
                            moq={this.getMoq()} />
                        <div className="error-message full-width">
                            <p className="not-enough-stock-error-container" style={{ display: 'none' }}>Not enough stock</p>
                            <p className="minimum-order-not-met-error-container" style={{ display: 'none' }}>Minimum order not met</p>
                        </div>*/
                        }
                    </div>
                </div>
                {/*
                <div className="idcrt-order-total pull-left w-100">
                    <OriginalPriceComponent
                        bulkPricing={this.props.bulkPricing}
                        currencyCode={this.props.itemDetails.CurrencyCode}
                        priceValues={this.props.priceValues} />
                    <span className="pull-left">Sub Total:</span>
                    <span className="total-price pull-right">
                        <div className="item-price">
                            {this.renderFormatMoney(this.props.itemDetails.CurrencyCode, this.props.priceValues.bulkPrice)}
                        </div>
                    </span>
                </div>*/
                }
            </div>
        );
    }
}

module.exports = PurchaseOrderComponent;
